export const ALL_DOSSIER_REQUEST = "ALL_DOSSIER_REQUEST";
export const ALL_DOSSIER_SUCCESS = "ALL_DOSSIER_SUCCESS";
export const ALL_DOSSIER_FAIL = "ALL_DOSSIER_FAIL";
export const ALL_DOSSIER_RESET = "ALL_DOSSIER_RESET";
